import type { CountryLocalizations, TextLocalization } from '../types';

export const danishLocalization: TextLocalization = {
  inputPlaceholder: 'Telefonnummer',
  inputInputLabel: 'Skriv dit nummer for at betale med {marketBrandName}',
  inputPrimaryLabel: 'Fortsæt for at betale med {marketBrandName}',
  useSavedNumberButton: 'Brug mit gemte {marketBrandName}-nummer',
  continueAsLabel: 'Fortsæt som {0}',
  useAnotherNumberLabel: 'Brug et andet nummer',
  rememberMeLabel: 'Husk mit nummer',
  inputPrimary: 'Næste',
  inputCancel: 'Afbryd betalingen',
  inputCancelLabel: 'Afbryd betalingen og gå tilbage til webshoppen',
  logoTitle: '{marketBrandName} logo',
  localeSelectorLabel: 'Valg af sprog, {0} valgt',
  countryCodeSelectorLabel: 'Vælg land, {0} valgt',
  statusHeader: 'Åbn {marketBrandName}',
  statusAriaLabel:
    'Du har {0} minutter and {1} sekunder til at åbne {marketBrandName} og gennemføre betalingen.',
  statusContent: 'Vi har sendt en betalingsanmodning til {0}',
  errorHeader: 'Ups, noget gik galt',
  errorContent: 'Prøv igen.',
  errorPrimary: 'Gå tilbage',
  timeoutHeader: 'Åh nej, tiden løb ud',
  timeoutContent: 'Gå tilbage og prøv igen.',
  timeoutPrimary: 'Gå tilbage',
  scanToOpenInKlarna: 'Scan for at tilføje Klarna til {marketBrandName}',
  addKlarna: 'Tilføj Klarna til {marketBrandName}',
  openVipps: 'Åbn {marketBrandName}',
  openInKlarnaMobileText: 'Fra en mobil? Tryk her',
  inputCountryCodeLabel: 'Landekode',
  inputError: 'For at fortsætte skal du have installeret {marketBrandName} på din mobil.',
  inputErrorNoEdit: 'Denne butik kræver at du bruger samme mobilnummer som i din profil.',
  statusNumberFallback: 'dit nummer',
  dropDownOptionsLabel: 'Alternativer',
  qrAltTag: 'QR-kode til betaling',
  qrSeparator: 'eller brug dit telefonnummer',
  upgradeApp: 'Ser du denne tekst? Opdater din app.',
  cookieDeclarationText:
    'Vi bruger kun de cookies, der er nødvendige for, at vores hjemmeside fungerer korrekt.',
  cookieDeclarationLink: 'Læs mere i vores {cookieDeclaration}.',
  cookieDeclaration: 'cookieerklæring',
  scanToPay: 'Scan og betal',
  paymentTo: 'til',
  skipToContent: 'Spring til indhold',
  inputHeadingAmount: 'Betal {0} til {1}',
  inputHeadingRecurring: 'Betal til {0}',
  inputDescription: 'Indtast dit telefonnummer og gennemfør betalingen i {marketBrandName}.',
  inputDescriptionQr: 'Scan QR-koden og gennemfør betalingen i {marketBrandName}.',
};

export const danishCountryLocalization: CountryLocalizations = {
  britain: {
    country: '',
    language: 'Engelsk',
  },
  denmark: {
    country: 'Danmark',
    language: 'Dansk',
  },
  finland: {
    country: 'Finland',
    language: 'Finsk',
  },
  norway: {
    country: 'Norge',
    language: 'Norsk',
  },
  sweden: {
    country: 'Sverige',
    language: 'Svensk',
  },
  greenland: {
    country: 'Grønland',
    language: 'Engelsk',
  },
};
